<template>
  <div class="container">
    <div>
      <i class="el-icon-rank"></i>
    </div>
    <div class="middle">
      <el-input
        :value="value.content"
        @input="edit('content', $event, value)"
        placeholder="请输入科目名"
      ></el-input>
    </div>
    <div class="middle">
      <i
        class="el-icon-remove-outline"
        @click="edit('delete', $event, value)"
      ></i>
    </div>
    <div class="middle"><span>考试难度</span></div>
    <div class="middle">
      <el-rate
        :value="value.anotherContent * 1"
        @change="edit('anotherContent', $event, value)"
      ></el-rate>
    </div>

    <!-- <el-row :gutter="20" :align="'middle'">
  <el-col :span="12"><el-input v-model="input" placeholder="请输入内容"></el-input></el-col>
  <el-col :span="2"><i class="el-icon-remove-outline"></i></el-col>
<el-col :span="3"><span>考试难度</span></el-col>
<el-col :span="7"><el-rate v-model="value1"></el-rate></el-col>

</el-row> -->
    <!-- <el-row :gutter="20" align="middle">
  <el-col :span="10"><div class="middle"><el-input v-model="input" placeholder="请输入内容"></el-input></div></el-col>
  <el-col :span="1"><div class="middle"><i class="el-icon-remove-outline"></i></div></el-col>
  <el-col :span="4"><div class="middle"><span>考试难度</span></div></el-col>
  <el-col :span="6"><div class="middle">  <el-rate v-model="value1"></el-rate></div></el-col>
</el-row> -->
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: {},
    },
    title: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  name: "",

  data() {
    return {};
  },

  created() {},
  methods: {
    //#region 表单
    add() {},
    edit(type, val, prop) {
      //console.log(type,val,prop);
      if (type === "delete") {
        this.$emit("upLoad", prop, true, this.index);
      } else {
        let copyProp = JSON.parse(JSON.stringify(prop));
        console.log("event", val);
        copyProp[type] = val;
        this.$emit("upLoad", copyProp, false, this.index);
        console.log("prop", copyProp);
      }
      //  this.$emit('change',)
    },
    dele(record) {},
    showForm(params = {}) {},
  },
};
</script >
<style lang="less" scoped>
.container {
  i,
  span {
    font-size: 16px;
  }
  i:hover {
    color: #4e8ef7;
    cursor: pointer;
  }
  span {
    font-size: 16px;
    color: #646464;
  }
  display: flex;
  align-items: center;
  width: 50%;
  & > div:nth-of-type(1) {
    margin-right: 1rem;
  }
  & > div:nth-of-type(2) {
    flex: 5;
  }
  & > div:nth-of-type(3) {
    margin-left: 1rem;
    /*   flex: 1; */
  }
  & > div:nth-of-type(4) {
    margin-left: 1rem;
    flex: 1.5;
  }
  & > div:nth-of-type(5) {
    flex: 3;
  }
  .middle {
    display: flex;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/addGuide/components/ExamCourse.vue